import api from "../api/api";   

class AuxService {
    
    async getPermissions() {
        return await api.get(`permissions_disponiveis`).then(res => res.data).catch(() => []);
    }

    async getProfiles() {
        return await api.get(`profiles_disponiveis`).then(res => res.data).catch(() => []);
    }

    async getEmpresas() {
        return await api.get(`empresas_disponiveis`).then(res => res.data).catch(() => []);
    }

    async getEstados() {
        return await api.get(`estado/list/all`).then(res => res.data).catch(() => []);
    }

    async getMunicipios(estado_id: number) {
        return await api.get(`municipio/list/${estado_id}`).then(res => res.data).catch(() => []);
    }

    async getMunicipiosByUf(uf: string) {
        return await api.get(`municipio/list/uf/${uf}`).then(res => res.data).catch(() => []);
    }

    async postRegister(data: any) {
        return await api.post(`register`, data).then(res => res.data);
    }

    async getTenant() {
        return await api.get(`tenant-user`).then(res => res.data).catch(() => []);
    }

    async getCondutores() {
        return await api.get('condutor/list/all').then(res => res.data).catch(() => []);
    }

    async getCertificados() {
        return await api.get('certificados').then(res => res.data).catch(() => []);
    }

    async postCertificado(data: any) {
        return await api.post('certificados', data).then(res => res.data)
    }

    async getNextNumManifesto() {
        return await api.get('manifesto/operacao/nextnum').then(res => res.data).catch(() => []);
    }

    async getUserCurrent() {
        return await api.get('user').then(res => res.data).catch(() => []);
    }
    
}

const auxService = new AuxService();

export default auxService;